/* YAP fly to cart (owner, 2026-09-29): after a successful add to cart, the added product's photo flies in an arc into the
   cart icon, the cart bounces and the button reads "Added" for a moment. Since 2026-10-21 Empire's "Added to your cart" box
   (View cart, Checkout) opens after the flight lands, and right away when an add fails (html.yap-atc-show). The photo always comes from Shopify's add response (the product
   that was really added); the page only decides where the flight starts (the card photo, else the button pressed).
   Works for card buttons, product pages, the sticky bar, quick shop and any kit that posts to /cart/add.
   Reduced motion: no flight, the cart still bounces. */
(function () {
  if (window.__yapFly) return;
  window.__yapFly = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var last = null, opener = null;
  var ATC = '[data-quick-buy], [data-product-atc], [data-add-to-cart], .yap-sticky-atc button, [class*="sticky-atc"] button, form[action*="/cart/add"] [type="submit"], [data-yap-atc]';

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 8 && r.height > 8 && r.bottom > 0 && r.top < window.innerHeight;
  }
  function cardImg(el) {
    var card = el && el.closest('.productitem, [data-product-item]');
    var im = card && card.querySelector('img.productitem--image-primary, .productitem--image-primary img, .productitem--image img:not(.productitem--image-alternate)');
    return im && visible(im) ? im : null;
  }
  function galleryImg() {
    var list = document.querySelectorAll('.product-gallery .swiper-slide-active img, .product-gallery img, [data-product-gallery] img');
    for (var i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
    return null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var o = e.target.closest('[data-quickshop-slim], [data-quickshop-full]');
    if (o) opener = { btn: o, t: Date.now() };
    var b = e.target.closest(ATC);
    if (b) last = { btn: b, t: Date.now() };
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1 && !(last && Date.now() - last.t < 1500)) last = { btn: f.querySelector('[type="submit"]') || f, t: Date.now() };
  }, true);

  // "You recently viewed" cards: Empire shows their buttons but does not wire them, so they are handled here.
  // Add to cart posts to /cart/add.js (the fly effect below picks it up) and refreshes the header count;
  // Choose options opens the product page.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest('.product-recently-viewed-card');
    var btn = card && e.target.closest('.productitem--action-atc');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!btn.hasAttribute('data-quick-buy')) {
      var url = card.getAttribute('data-product-quickshop-url') || (card.querySelector('a[href*="/products/"]') || {}).href;
      if (url) window.location.href = url;
      return;
    }
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('processing')) return;
    btn.classList.add('processing');
    last = { btn: btn, t: Date.now() };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); })
      .catch(function () {})
      .then(function () { btn.classList.remove('processing'); });
  }, true);

  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  function firstItem(d) { return d && (d.items && d.items[0] ? d.items[0] : d); }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__yapAdd = String(m).toUpperCase() === 'POST' && isAdd(u); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__yapAdd) {
      var x = this;
      x.addEventListener('loadend', function () {
        var d = null;
        try { d = typeof x.response === 'object' && x.response ? x.response : JSON.parse(x.responseText); } catch (e) {}
        done(x.status >= 200 && x.status < 300, firstItem(d));
      });
    }
    return xs.apply(this, arguments);
  };
  if (window.fetch) {
    var f0 = window.fetch;
    window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : input && input.url;
      var m = (init && init.method) || (input && input.method) || 'GET';
      var p = f0.apply(this, arguments);
      if (String(m).toUpperCase() === 'POST' && isAdd(u)) {
        p.then(function (r) {
          r.clone().json().then(function (d) { done(r.ok, firstItem(d)); }, function () { done(r.ok, null); });
        }, function () { done(false, null); });
      }
      return p;
    };
  }

  var live;
  function announce(msg) {
    if (!live) { live = document.createElement('div'); live.className = 'yap-sr'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50);
  }
  function target() {
    var best = null;
    document.querySelectorAll('.yap-mob-bar__cart, .site-header-cart--button').forEach(function (el) {
      if (!visible(el) || getComputedStyle(el).visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (!best || r.top < best.r.top) best = { el: el, r: r };
    });
    return best;
  }
  function bump(t) {
    var els = t ? [t.el] : [].slice.call(document.querySelectorAll('.yap-mob-bar__cart, .site-header-cart--button'));
    els.forEach(function (el) {
      if (!el.animate) return;
      el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(.9)' }, { transform: 'scale(1.06)' }, { transform: 'scale(1)' }], { duration: 520, easing: 'ease-out' });
      var c = el.querySelector('.site-header-cart--count');
      if (c && c.animate) c.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 480, delay: 60, easing: 'ease-out' });
    });
  }
  function mark(btn) {
    var t = btn && btn.querySelector && btn.querySelector('.atc-button--text');
    if (!t || t.__yapOld) return;
    t.__yapOld = t.innerHTML;
    t.textContent = 'Added ✓';
    btn.classList.add('yap-added');
    setTimeout(function () { t.innerHTML = t.__yapOld; t.__yapOld = null; btn.classList.remove('yap-added'); }, 1700);
  }
  function sized(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fly(src, from, big, t) {
    if (!src || !from || reduce || !document.body.animate) { bump(t); return; }
    var r = from.getBoundingClientRect();
    var size = big ? Math.max(72, Math.min(r.width, r.height, 170)) : 96;
    var sx = r.left + r.width / 2, sy = r.top + r.height / 2;
    var tx = t ? t.r.left + t.r.width / 2 : window.innerWidth - 30, ty = t ? t.r.top + t.r.height / 2 : 30;
    var g = document.createElement('div'), gy = document.createElement('div'), im = new Image();
    g.className = 'yap-fly'; gy.className = 'yap-fly__y'; g.setAttribute('aria-hidden', 'true');
    im.src = src; im.alt = '';
    g.style.cssText = 'left:' + (sx - size / 2) + 'px;top:' + (sy - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
    var started = false;
    function go() {
      if (started) return; started = true;
      gy.appendChild(im); g.appendChild(gy); document.body.appendChild(g);
      run();
    }
    // wait for the photo (from the page it is instant; a fresh download gets up to 700 ms), never fly a blank card
    if (im.decode) { im.decode().then(go, go); setTimeout(go, 700); } else { im.onload = go; setTimeout(go, 700); }
    function run() {
    var dur = 900, end = 26 / size;
    // X eases out and Y eases in, so the photo curves up and over into the basket
    g.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (tx - sx) + 'px)' }], { duration: dur, easing: 'cubic-bezier(.25,.6,.35,1)', fill: 'forwards' });
    gy.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(' + (ty - sy) + 'px)' }], { duration: dur, easing: 'cubic-bezier(.65,0,.85,.4)', fill: 'forwards' });
    var a = im.animate([
      { transform: 'scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: 'scale(1.06) rotate(-4deg)', opacity: 1, offset: 0.12 },
      { transform: 'scale(.45) rotate(4deg)', opacity: 1, offset: 0.5 },
      { transform: 'scale(' + end + ') rotate(14deg)', opacity: 0.6, offset: 1 }
    ], { duration: dur, easing: 'ease-in-out', fill: 'forwards' });
    var finished = false;
    function finish() { if (finished) return; finished = true; if (g.parentNode) g.parentNode.removeChild(g); bump(t); }
    a.onfinish = finish;
    setTimeout(finish, dur + 400);
    }
  }
  function done(ok, item) {
    var ctx = last && Date.now() - last.t < 15000 ? last : null;
    last = null;
    var h = document.documentElement;
    if (!ok) { h.classList.add('yap-atc-show'); setTimeout(function () { h.classList.remove('yap-atc-show'); }, 8000); return; }
    h.classList.remove('yap-atc-show');
    announce('Added to cart');
    var btn = ctx && ctx.btn;
    if (btn) mark(btn);
    // where the flight starts: the card photo, else the product photo on screen, else the card that opened quick shop, else the button
    var from = cardImg(btn), big = !!from;
    if (!from && btn && !btn.closest('[class*="quickshop"], .modal, [role="dialog"]')) { from = galleryImg(); big = !!from; }
    if (!from && opener && Date.now() - opener.t < 120000) { from = cardImg(opener.btn); big = !!from; }
    if (!from && btn && visible(btn)) from = btn;
    // the photo: the one already on the page when it shows this product (instant), else the image in Shopify's reply
    var src = from && from.tagName === 'IMG' ? (from.currentSrc || from.src) : sized(item && (item.image || (item.featured_image && item.featured_image.url)), 300);
    fly(src, from, big, target());
    // Conversion fix (Stunner, 2026-10-21): once the photo lands, show Empire's "Added to your cart" box too, so the
    // shopper sees View cart and Checkout instead of only a bounce on the cart icon. Empire's own close button hides it.
    setTimeout(function () { h.classList.add('yap-atc-show'); }, reduce ? 0 : 1100);
  }
})();
